<br />
<mat-expansion-panel class="margen-expansion" expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Informe De Productos</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <app-filtro-grupo-linea-marca
    (propagar)="dataFiltro($event)"
  ></app-filtro-grupo-linea-marca>
</mat-expansion-panel>

<br />
<mat-expansion-panel class="margen-expansion" expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Resultados</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="row">
    <div class="col s12 m12 l12" style="text-align: center" [hidden]="!loading">
      <mat-spinner
        [diameter]="100"
        style="margin: 0 auto; top: 15px"
      ></mat-spinner>
    </div>
    <div class="col s12 m12 l12" [hidden]="loading">
      <table
        [hidden]="!haveData"
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        class="display"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th>Código Producto</th>
            <th>Descripción</th>
            <th>Grupo</th>
            <th>Linea</th>
            <th>Marca</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dataProducto">
            <td style="text-align: center">{{ item.idExProducto }}</td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.descGrupo }}</td>
            <td>{{ item.descLinea }}</td>
            <td>{{ item.descMarca }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</mat-expansion-panel>
